export interface ViewerCapabilities {
  layouts: {
    manage: boolean;
    uploadImage: boolean;
    uploadPdf: boolean;
    reusePdfAsset: boolean;
    copyPdfConfiguration: boolean;
    detachPdf: boolean;
  };
  markers: {
    edit: boolean;
    resequence: boolean;
  };
  areaTags: {
    create: boolean;
    edit: boolean;
    delete: boolean;
  };
  hotspots: {
    create: boolean;
    edit: boolean;
    delete: boolean;
  };
}

export interface ViewerCapabilityOverrides {
  layouts?: Partial<ViewerCapabilities['layouts']>;
  markers?: Partial<ViewerCapabilities['markers']>;
  areaTags?: Partial<ViewerCapabilities['areaTags']>;
  hotspots?: Partial<ViewerCapabilities['hotspots']>;
}

export const DEFAULT_VIEWER_CAPABILITIES: Readonly<ViewerCapabilities> = Object.freeze({
  layouts: Object.freeze({
    manage: false,
    uploadImage: false,
    uploadPdf: false,
    reusePdfAsset: false,
    copyPdfConfiguration: false,
    detachPdf: false,
  }),
  markers: Object.freeze({
    edit: false,
    resequence: false,
  }),
  areaTags: Object.freeze({
    create: false,
    edit: false,
    delete: false,
  }),
  hotspots: Object.freeze({
    create: false,
    edit: false,
    delete: false,
  }),
});

export const createViewerCapabilities = (
  overrides: ViewerCapabilityOverrides = {},
): ViewerCapabilities => ({
  layouts: {
    ...DEFAULT_VIEWER_CAPABILITIES.layouts,
    ...overrides.layouts,
  },
  markers: {
    ...DEFAULT_VIEWER_CAPABILITIES.markers,
    ...overrides.markers,
  },
  areaTags: {
    ...DEFAULT_VIEWER_CAPABILITIES.areaTags,
    ...overrides.areaTags,
  },
  hotspots: {
    ...DEFAULT_VIEWER_CAPABILITIES.hotspots,
    ...overrides.hotspots,
  },
});
